import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, ModelNumStrNav, TicketsCategorie, ITicketsCategorie_TableModel } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class TicketsCategorieService extends CrudGenericsService<TicketsCategorie, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/TicketsCategorie`);
    this.base = `${env.apiUrl}/api/TicketsCategorie/`;
  }
  // per la tabella
  GetTicketsCategorie_TableModel(): Observable<ITicketsCategorie_TableModel[]> {
    const u = this.base + 'GetTicketsCategorie_TableModel';
    return this.http.get<ITicketsCategorie_TableModel[]>(`${u}`);
  }
  Get4Select_TicketTipoNavigation(): Observable<ModelNumStrNav[]> {
    const u = this.base + 'Get4Select_TicketTipoNavigation';
    return this.http.get<ModelNumStrNav[]>(`${u}`);
  }
}
